import React, { useEffect } from "react";
import "../facilitiesMaster/facilitiesMaster.scss";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import FacilitiesDetails from "../../components/FacilitiesMaster/CompanyDetails";
import useForm from "./useForm";
import FetchData from "../../providers/dataProvider";
import { useLocation } from "react-router-dom";
import ErrorMessage from "../../components/common/ErrorMessage";

const AddNewFacilities = () => {
  const location = useLocation();
  const companyContext = location?.state?.companyId;
  const {
    data: companydata,
    loading: companyLoading,
    error: companyError,
  } = FetchData("company");
  const {
    data: countrydata,
    loading: countryLoading,
    error: countryError,
  } = FetchData("country");
  const {
    data: facilityData,
    loading: facilityLoading,
    error: facilityError,
  } = FetchData("manufacturingFacility", {
    companyId:
      companyContext ||
      JSON.parse(localStorage.getItem("userProfile"))?.userCompanyId ||
      "",
  });

  const {
    HandleFormChange,
    formValues,
    country,
    company,
    HandleCompanyChange,
    HandleCountryChange,
    HandleFormSubmit,
    formErrors,
    createMsg,
    show,
    setShow,
    errorShow,
    SuccessDoneClick,
    ErrorDoneClick,
    ClearFormValues,
    setCountry,
    setCompany,
    setFormError,
  } = useForm(facilityData, countrydata, companydata);

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent("pathfinderHeaderMetaChange", {
        detail: {
          pathname: location.pathname,
          title: formValues?.id
            ? `Facility : ${formValues?.facilityName || formValues?.facilityCode || "Edit"}`
            : "New Facility",
          backTarget: {
            pathname: "/facility-master",
            state: {
              companyId:
                formValues?.companyId ||
                companyContext ||
                JSON.parse(localStorage.getItem("userProfile"))?.userCompanyId ||
                "",
            },
          },
        },
      })
    );

    return () => {
      window.dispatchEvent(
        new CustomEvent("pathfinderHeaderMetaChange", {
          detail: {
            pathname: location.pathname,
            clear: true,
          },
        })
      );
    };
  }, [
    location.pathname,
    formValues?.id,
    formValues?.facilityName,
    formValues?.facilityCode,
    formValues?.companyId,
    companyContext,
  ]);

  return (
    <div className="container-fluid add-new-facility-sec">
      <section className="company-add-sec">
        <div className="row m-0">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
            <FacilitiesDetails
              HandleFormChange={HandleFormChange}
              formValues={formValues}
              companydata={companydata}
              HandleCompanyChange={HandleCompanyChange}
              company={company}
              countrydata={countrydata}
              formErrors={formErrors}
              HandleCountryChange={HandleCountryChange}
              country={country}
              setCountry={setCountry}
              setCompany={setCompany}
              setFormError={setFormError}
              HandleFormSubmit={HandleFormSubmit}
              ClearFormValues={ClearFormValues}
            />
          </div>
        {/* <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">
                <div className="save-btns d-flex justify-content-end">
                  <button className="btn cancel-btn" onClick={ClearFormValues}>
                    Cancel
                  </button>
                  <button className="btn save-btn" onClick={HandleFormSubmit}>
                    {!formValues?.id ? "Save" : "Update"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        </div>
      </section>

      <ErrorMessage
        Show={errorShow?.show}
        errorMessage={errorShow?.errorMessage}
        ErrorDoneClick={ErrorDoneClick}
      />

      <SaveSuccessModel
        show={show}
        createMsg={createMsg}
        setShow={setShow}
        SuccessDoneClick={SuccessDoneClick}
      />
    </div>
  );
};

export default AddNewFacilities;
